// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__Qn6+5","root":"Button_root__j5CKF","icon":"Button_icon__KeIH3","loading":"Button_loading__2RI7O","button-loading":"Button_button-loading__sHF9+"};